/* global $:true plyr:true */

/*
Store Location Behaviour

This behaviour attachs to static markup in a result list representing a collection of store locations.

Each store location component will:
1. contain visual elements used inside the map when a marker is clicked. here we do a simple ephemeral clone and append.
2. describe meta data about the store location as attributes (in the standard fusion jquery behaviour form `pluginname-option`)
3. Provide the meta data to the map component so it can place it as a marker.
4. This component should provide a method that controls how the markup displayed in the map popover is sourced.

Styleguide: STR001.Components.StoreLocationBehaviour
*/
import debug from "debug";

import { MODULE_NAME } from './index';
import googleMapsApiPromise from '../../services/google-maps-api';
import LocationMarker from '../store-locator-map/location-marker';
const log = debug(MODULE_NAME);

export class StoreLocation {

    constructor(element, options) {
        this.element = element;
        this.$element = $(element);
        this.options = options;

        if (this.options.revealMarkerOn) {
            this.$markerToggle = this.$element.find(this.options.revealMarkerSelector);
        }
        log('construct', this.element);

        this.markerTemplate = document.getElementById(
			this.options.markerTemplateId
		);

        googleMapsApiPromise.then((google) => {
            this.google = google;
            const $mapElement = $(this.options.mapSelector);
            this.mapComponent = $mapElement && $mapElement.behaviour('storeLocatorMap');

            this.init();
        });
    }


    init () {

        // register this store location as a marker
        this.mapComponent && this.mapComponent.on('clustererReady', () => {

            const marker = new LocationMarker({
				id: this.options.id,
				lat: this.options.lat,
				lng: this.options.lng,
				type: this.options.type,

				isHighlighted: false,
				resultItem: this,
				templateEl: this.markerTemplate,
                popoverContent: this.options.popover && this.popoverContent,
			});
			marker.setMarkerIcons(this.mapComponent.markerIcons);

            this.mapComponent
				.addMarker(
					marker
				)
				.then((locationMarker) => {
					if (this.element) {
						this.element.addEventListener(
							"mouseover",
							this.onHover.bind(this, locationMarker)
						);
					}
                    if (this.$markerToggle && this.$markerToggle.length) {
                        this.$markerToggle.addClass(this.options.markerToggleClickableClass);
                        this.$markerToggle.on(this.options.revealMarkerOn, () => {
                            const $mapElement = this.mapComponent.$element;
                            const mapElementTop = $mapElement.offset().top;
                            const documentTop = $(document).scrollTop();
                            if (documentTop > mapElementTop) {
                                $(document).scrollTop(mapElementTop);
                            }
                            this.mapComponent.panAndOpenMarkerPopover(locationMarker);
                        });
                        log('init.toggleListen', this.$markerToggle);
                    }
				}).catch((error)=>{
					log("Marker not added");
				});

        });

    }

    highlight() {
		if (!this.element) {
			return false;
		}
		this.element.classList.add(this.options.highlightClass);
	}

	unhighlight() {
		if (!this.element) {
			return false;
		}
		this.element.classList.remove(this.options.highlightClass);
	}

    onHover(locationMarker) {
		locationMarker.hoverMarker();
		window.addEventListener(
			"mouseover",
			this.unhoverMarker.bind(this, locationMarker),
			{once: true}
		);
	}

	unhoverMarker(locationMarker, event) {
		if (
			event.target !== this.element &&
			!this.element.contains(event.target)
		) {
			locationMarker.unhoverMarker();
		}
	}

    get popoverContent () {
        return this.$element
            .find(this.options.popoverContentSelector)
            .clone()
            .find(this.options.popoverExclusionFilter).remove().end()
            .html();
    }

}

StoreLocation.DEFAULTS = {
    mapSelector: '[data-store-locator-map]',
    markerIcon: null,
    markerLabel: '',
    popover: true,
    popoverContentSelector: '[data-popover-content]',
    popoverExclusionFilter: '[data-popover-exclude]',
    showsMarkerOnClick: true,
    revealMarkerOn: 'click',
    revealMarkerSelector: '.store-locator-result__marker-toggle-button',
    markerToggleClickableClass: 'u--pointer',
    type: 'store',
};



// WEBPACK FOOTER //
// ./project/client/src/core/modules/store-location/component.js